'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _sagaCreator;

var _reduxSaga = require('redux-saga');

var _effects = require('redux-saga/effects');

var _HistoryManagerActions = require('../actions/HistoryManagerActions');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(historyDispatcher),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(runTask),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(listenToCancel),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(takeWithCancel);

// ============================================================================
// SAGAS
// ============================================================================

var initHistory = function initHistory(_ref) {
    var HistoryManager = _ref.HistoryManager,
        window = _ref.window;
    return (/*#__PURE__*/_regenerator2.default.mark(function _callee(_ref2) {
            var payload = _ref2.payload;
            var useBrowserHistory, initialState;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            useBrowserHistory = payload.useBrowserHistory, initialState = payload.initialState;

                            HistoryManager.init(window, !!useBrowserHistory);

                            if (!initialState) {
                                _context.next = 5;
                                break;
                            }

                            _context.next = 5;
                            return (0, _effects.call)(pushState({ HistoryManager: HistoryManager }), { payload: { state: initialState } });

                        case 5:
                            _context.next = 7;
                            return (0, _effects.takeEvery)(historyChannel(HistoryManager), historyDispatcher);

                        case 7:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        })
    );
};

var pushState = function pushState(_ref3) {
    var HistoryManager = _ref3.HistoryManager;
    return (/*#__PURE__*/_regenerator2.default.mark(function _callee2(_ref4) {
            var payload = _ref4.payload;
            var state;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            state = payload.state;

                            HistoryManager.pushState(state);

                        case 2:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        })
    );
};

var go = function go(_ref5) {
    var HistoryManager = _ref5.HistoryManager;
    return (/*#__PURE__*/_regenerator2.default.mark(function _callee3(_ref6) {
            var payload = _ref6.payload;
            var position;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            position = payload.position;

                            HistoryManager.go(position);

                        case 2:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        })
    );
};

var goBack = function goBack(_ref7) {
    var HistoryManager = _ref7.HistoryManager;
    return (/*#__PURE__*/_regenerator2.default.mark(function _callee4() {
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.next = 2;
                            return (0, _effects.call)(go({ HistoryManager: HistoryManager }), { payload: { position: -1 } });

                        case 2:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        })
    );
};

var resetHistory = function resetHistory(_ref8) {
    var HistoryManager = _ref8.HistoryManager;
    return (/*#__PURE__*/_regenerator2.default.mark(function _callee5() {
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            HistoryManager.reset();

                        case 1:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this);
        })
    );
};

// ============================================================================
// HELPERS
// ============================================================================

function historyDispatcher(state) {
    return _regenerator2.default.wrap(function historyDispatcher$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return (0, _effects.put)(_HistoryManagerActions.actions.stateUpdate({ state: state }));

                case 2:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked, this);
}

function historyChannel(HistoryManager) {
    return (0, _reduxSaga.eventChannel)(function (emitter) {
        HistoryManager.onPopstate(function (_ref9) {
            var state = _ref9.state;

            state = state || '@@none';
            emitter(state);
        });

        return function () {
            HistoryManager.onPopstate(function () {});
        };
    });
}

// ============================================================================
// SAGA CREATOR
// ============================================================================

function runTask(takerFunc, pattern, saga) {
    for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        args[_key - 3] = arguments[_key];
    }

    return _regenerator2.default.wrap(function runTask$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.next = 2;
                    return (0, _effects.fork)( /*#__PURE__*/_regenerator2.default.mark(function _callee6() {
                        return _regenerator2.default.wrap(function _callee6$(_context7) {
                            while (1) {
                                switch (_context7.prev = _context7.next) {
                                    case 0:
                                        _context7.next = 2;
                                        return takerFunc.apply(undefined, [pattern, saga].concat(args));

                                    case 2:
                                    case 'end':
                                        return _context7.stop();
                                }
                            }
                        }, _callee6, this);
                    }));

                case 2:
                    return _context8.abrupt('return', _context8.sent);

                case 3:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked2, this);
}

function listenToCancel(cancelPatterns, task, taker, pattern, saga) {
    for (var _len2 = arguments.length, args = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
        args[_key2 - 5] = arguments[_key2];
    }

    return _regenerator2.default.wrap(function listenToCancel$(_context9) {
        while (1) {
            switch (_context9.prev = _context9.next) {
                case 0:
                    if (!true) {
                        _context9.next = 10;
                        break;
                    }

                    _context9.next = 3;
                    return (0, _effects.take)(cancelPatterns);

                case 3:
                    _context9.next = 5;
                    return (0, _effects.cancel)(task);

                case 5:
                    _context9.next = 7;
                    return _effects.fork.apply(undefined, [runTask, taker, pattern, saga].concat(args));

                case 7:
                    task = _context9.sent;
                    _context9.next = 0;
                    break;

                case 10:
                case 'end':
                    return _context9.stop();
            }
        }
    }, _marked3, this);
}

function takeWithCancel() {
    var isLatest = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var pattern = arguments[1];
    var cancelPatterns = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var saga = arguments[3];

    for (var _len3 = arguments.length, args = Array(_len3 > 4 ? _len3 - 4 : 0), _key3 = 4; _key3 < _len3; _key3++) {
        args[_key3 - 4] = arguments[_key3];
    }

    var taker, task;
    return _regenerator2.default.wrap(function takeWithCancel$(_context10) {
        while (1) {
            switch (_context10.prev = _context10.next) {
                case 0:
                    taker = isLatest ? _effects.takeLatest : _effects.takeEvery;
                    _context10.next = 3;
                    return _effects.fork.apply(undefined, [runTask, taker, pattern, saga].concat(args));

                case 3:
                    task = _context10.sent;


                    if (_lodash2.default.isString(cancelPatterns)) {
                        cancelPatterns = [cancelPatterns];
                    }

                    if (!(_lodash2.default.isArray(cancelPatterns) && cancelPatterns.length > 0)) {
                        _context10.next = 8;
                        break;
                    }

                    _context10.next = 8;
                    return _effects.fork.apply(undefined, [listenToCancel, cancelPatterns, task, taker, pattern, saga].concat(args));

                case 8:
                case 'end':
                    return _context10.stop();
            }
        }
    }, _marked4, this);
}

var generateWatcher = function generateWatcher(sagaParams, actionType, callback) {
    return (/*#__PURE__*/_regenerator2.default.mark(function _callee7() {
            var cancelOn;
            return _regenerator2.default.wrap(function _callee7$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            if (!_lodash2.default.isFunction(callback)) {
                                _context11.next = 5;
                                break;
                            }

                            _context11.next = 3;
                            return (0, _effects.takeEvery)(actionType, callback(sagaParams));

                        case 3:
                            _context11.next = 8;
                            break;

                        case 5:
                            if (!_lodash2.default.isFunction(callback.fn)) {
                                _context11.next = 8;
                                break;
                            }

                            cancelOn = callback.cancelOn || [];
                            return _context11.delegateYield(takeWithCancel(!!callback.takeLatest, actionType, cancelOn, callback.fn(sagaParams)), 't0', 8);

                        case 8:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee7, this);
        })
    );
};

function sagaCreator(actionConfig) {
    return (/*#__PURE__*/_regenerator2.default.mark(function sagaCreator(sagaParams) {
            var forks;
            return _regenerator2.default.wrap(function sagaCreator$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            forks = [];


                            _lodash2.default.forEach(actionConfig, function (callback, actionType) {
                                forks.push((0, _effects.fork)(generateWatcher(sagaParams, actionType, callback)));
                            });

                            _context12.next = 4;
                            return forks;

                        case 4:
                        case 'end':
                            return _context12.stop();
                    }
                }
            }, sagaCreator, this);
        })
    );
}

// ============================================================================
// EXPORT
// ============================================================================

exports.default = sagaCreator((_sagaCreator = {}, (0, _defineProperty3.default)(_sagaCreator, _HistoryManagerActions.types.INIT_HISTORY, { fn: initHistory, takeLatest: true }), (0, _defineProperty3.default)(_sagaCreator, _HistoryManagerActions.types.PUSH_STATE, { fn: pushState, takeLatest: true, cancelOn: [_HistoryManagerActions.types.RESET_HISTORY, _HistoryManagerActions.types.GO, _HistoryManagerActions.types.GO_BACK] }), (0, _defineProperty3.default)(_sagaCreator, _HistoryManagerActions.types.GO, { fn: go, takeLatest: true, cancelOn: [_HistoryManagerActions.types.RESET_HISTORY, _HistoryManagerActions.types.PUSH_STATE, _HistoryManagerActions.types.GO_BACK] }), (0, _defineProperty3.default)(_sagaCreator, _HistoryManagerActions.types.GO_BACK, { fn: goBack, takeLatest: true, cancelOn: [_HistoryManagerActions.types.RESET_HISTORY, _HistoryManagerActions.types.PUSH_STATE, _HistoryManagerActions.types.GO] }), (0, _defineProperty3.default)(_sagaCreator, _HistoryManagerActions.types.RESET_HISTORY, { fn: resetHistory, takeLatest: true }), _sagaCreator));